import { PopUpMessageContext, usePopUpMessage } from '@hb/react'
import { deleteField, DocumentReference, getDoc, setDoc, updateDoc } from 'firebase/firestore'
import { useCallback, useContext } from 'react'

export const useUpdateDoc = (itemName = 'patient', noSuccessToast = false) => {
  const { processResponse } = usePopUpMessage()
  return useCallback(
    async (ref: DocumentReference | null | undefined, path: string, data: any) => {
      if (!ref) {
        return processResponse({ error: 'Error - ref is null or undefined' })
      }

      const curr = (await getDoc(ref)).data()

      if (!curr) {
        await setDoc(ref, {}, { merge: true })
      }

      const promise = path ? updateDoc(ref, path, data) : updateDoc(ref, data)
      return promise
        .then(() => {
          if (noSuccessToast) return { success: `Updated ${itemName}!` }
          return processResponse({ success: `Updated ${itemName}!` })
        })

        .catch(err => {
          console.error(err)
          return processResponse({ error: `Error updating ${itemName}` })
        })
    },
    [processResponse, itemName, noSuccessToast],
  )
}

export const useDeleteDocData = (itemName = 'patient') => {
  const { processResponse } = useContext(PopUpMessageContext)
  return useCallback(
    async (ref: DocumentReference | null | undefined, path: string) => {
      if (!ref) {
        return processResponse({ error: 'Error - ref is null or undefined' })
      }
      return updateDoc(ref, path, deleteField())
        .then(() => processResponse({ success: `Deleted ${itemName}!` }))
        .catch(err => {
          console.error(err)
          return processResponse({ error: `Error deleting ${itemName}` })
        })
    },
    [processResponse, itemName],
  )
}
